import { Reveal } from "@components/ui";
import buttonArrowIcon from "@assets/images/Frame-91.svg";

const services = [
  {
    tag: "Residential Gas Supply",
    title: "Comfort and Safety for Every Home.",
    description:
      "Our residential gas services are engineered for convenience and safety. Whether you live in a villa or an apartment tower, GAZ provides a reliable source of energy for cooking, heating, and everyday needs.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6">
        <path d="M3 21V9l9-7 9 7v12H3z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 21V13h6v8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    iconColor: "#122d63",
  },
  {
    tag: "Commercial & Industrial Gas Systems",
    title: "High-Performance Energy for High-Demand Environments.",
    description:
      "From fine-dining restaurants to industrial factories, GAZ delivers large-scale, high-capacity gas systems tailored to your operational needs — ensuring compliance, efficiency, and uninterrupted service.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6">
        <path d="M3 21h18M5 21V7l7-4 7 4v14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 10h1M14 10h1M9 14h1M14 14h1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
    iconColor: "#f03813",
  },
  {
    tag: "Maintenance & Safety Services",
    title: "Regular Inspections. Reliable Systems. Peace of Mind.",
    description:
      "Safety is at the heart of every GAZ operation. Our certified technicians provide scheduled maintenance and quick-response services that keep your gas system safe, efficient, and compliant with UAE regulations.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6">
        <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94L14.7 6.3z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    iconColor: "#0a7c3e",
  },
];

export function ServicesGridSection() {
  return (
    <section className="w-full bg-[#f1f1f1] overflow-hidden py-12 md:py-16 lg:py-[100px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto flex flex-col gap-8 md:gap-12 lg:gap-16">
        {/* Header Row */}
        <Reveal direction="up">
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
            <div className="flex flex-col gap-3">
              <span className="inline-block self-start px-4 py-1.5 rounded-full bg-[#122d63]/8 text-[#122d63] text-[13px] md:text-[15px] font-semibold tracking-[-0.02em] uppercase">
                Our Services
              </span>
              <h2 className="text-[24px] md:text-[40px] lg:text-[56px] tracking-[-0.04em] font-bold text-[#122d63] font-albert-sans leading-[1.1] max-w-[906px]">
                We deliver end to end gas supply and support from network design to
                daily operation.
              </h2>
            </div>
            <button className="flex items-center justify-center gap-2.5 py-3 pl-4 pr-2 bg-[#090d2c] rounded-[40px] text-xs md:text-base lg:text-[24px] tracking-[-0.04em] text-white font-albert-sans hover:bg-[#3d405e] transition-colors shrink-0 self-start">
              <span>View all services</span>
              <img
                src={buttonArrowIcon}
                alt=""
                className="w-7 md:w-10 rounded-full"
              />
            </button>
          </div>
        </Reveal>

        {/* Service Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {services.map((service, index) => (
            <Reveal
              key={service.tag}
              direction="up"
              delay={index * 100}
              className="flex"
            >
              <div className="flex-1 rounded-[12px] md:rounded-[24px] bg-white overflow-hidden flex flex-col p-4 md:p-6 gap-4 md:gap-5 group hover:shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all duration-300 border border-transparent hover:border-[#e8e9ed]">
                {/* Tag + Icon + Title + Description */}
                <div className="flex flex-col gap-4 md:gap-6 flex-1">
                  <div className="flex flex-col gap-3 md:gap-4">
                    {/* Icon Container */}
                    <div
                      className="w-10 h-10 md:w-12 md:h-12 rounded-[12px] flex items-center justify-center"
                      style={{ backgroundColor: `${service.iconColor}14`, color: service.iconColor }}
                    >
                      {service.icon}
                    </div>
                    <span className="self-start rounded-full bg-[#ff2c00]/10 text-[#ff2c00] text-[12px] md:text-[14px] tracking-[-0.04em] font-semibold py-1 md:py-1.5 px-3 md:px-4">
                      {service.tag}
                    </span>
                    <h3 className="text-[20px] md:text-[24px] lg:text-[28px] tracking-[-0.04em] font-semibold text-[#1c1c1c] font-albert-sans leading-[1.2]">
                      {service.title}
                    </h3>
                  </div>
                  <p className="text-[14px] md:text-base lg:text-[18px] tracking-[-0.04em] leading-[1.45] text-[rgba(10,14,46,0.75)] font-albert-sans">
                    {service.description}
                  </p>
                </div>

                {/* Explore More Link */}
                <button className="flex items-center gap-2 md:gap-[13.8px] self-start bg-transparent border-none p-0 cursor-pointer">
                  <span className="text-[20px] md:text-[24px] lg:text-[27.6px] tracking-[-0.04em] font-medium text-[#090d2c] font-albert-sans group-hover:text-[#ff2c00] transition-colors">
                    Explore more
                  </span>
                  <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6 md:w-8 md:h-8 group-hover:translate-x-1 transition-transform">
                    <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
